import { StateUtils } from '@spartacus/core';
import { ORDER_REPEAT } from '../order-state';

export const ONLINE_ORDER_REPEAT = '[Order] Online Order Repeat';
export const ONLINE_ORDER_REPEAT_SUCCESS = '[Order] Online Order Repeat Success';
export const ONLINE_ORDER_REPEAT_FAIL = '[Order] Online Order Repeat Fail';

export class OnlineOrderRepeat extends StateUtils.LoaderLoadAction {
  readonly type = ONLINE_ORDER_REPEAT;

  constructor(public payload: { orderCode: string }) {
    super(ORDER_REPEAT);
  }
}

export class OnlineOrderRepeatSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = ONLINE_ORDER_REPEAT_SUCCESS;

  constructor() {
    super(ORDER_REPEAT);
  }
}

export class OnlineOrderRepeatFail extends StateUtils.LoaderFailAction {
  readonly type = ONLINE_ORDER_REPEAT_FAIL;

  constructor(public payload: unknown) {
    super(ORDER_REPEAT, payload);
  }
}

export type OnlineOrderRepeatActions = OnlineOrderRepeat | OnlineOrderRepeatSuccess | OnlineOrderRepeatFail;
